import * as Types from '../../../../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SetPatientTypeMutationVariables = Types.Exact<{
  input: Types.SetPatientTypeInput;
}>;


export type SetPatientTypeMutation = { readonly __typename?: 'Mutation', readonly setPatientType?: { readonly __typename?: 'Invoice', readonly _id: string, readonly patientType: Types.PatientType, readonly inpatientDetails?: { readonly __typename?: 'InpatientDetails', readonly ward?: string | null, readonly inpatientNumber?: string | null, readonly admission?: string | null, readonly discharge?: string | null } | null } | null };

export type InvoicePatientDetailsQueryVariables = Types.Exact<{
  invoiceId: Types.Scalars['String'];
}>;


export type InvoicePatientDetailsQuery = { readonly __typename?: 'Query', readonly invoice?: { readonly __typename?: 'Invoice', readonly _id: string, readonly patientType: Types.PatientType, readonly inpatientDetails?: { readonly __typename?: 'InpatientDetails', readonly ward?: string | null, readonly inpatientNumber?: string | null, readonly admission?: string | null, readonly discharge?: string | null } | null } | null };


export const SetPatientTypeDocument = gql`
    mutation setPatientType($input: SetPatientTypeInput!) {
  setPatientType(input: $input) {
    _id
    patientType
    inpatientDetails {
      ward
      inpatientNumber
      admission
      discharge
    }
  }
}
    `;
export type SetPatientTypeMutationFn = Apollo.MutationFunction<SetPatientTypeMutation, SetPatientTypeMutationVariables>;

/**
 * __useSetPatientTypeMutation__
 *
 * To run a mutation, you first call `useSetPatientTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPatientTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPatientTypeMutation, { data, loading, error }] = useSetPatientTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetPatientTypeMutation(baseOptions?: Apollo.MutationHookOptions<SetPatientTypeMutation, SetPatientTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPatientTypeMutation, SetPatientTypeMutationVariables>(SetPatientTypeDocument, options);
      }
export type SetPatientTypeMutationHookResult = ReturnType<typeof useSetPatientTypeMutation>;
export type SetPatientTypeMutationResult = Apollo.MutationResult<SetPatientTypeMutation>;
export type SetPatientTypeMutationOptions = Apollo.BaseMutationOptions<SetPatientTypeMutation, SetPatientTypeMutationVariables>;
export const InvoicePatientDetailsDocument = gql`
    query invoicePatientDetails($invoiceId: String!) {
  invoice(invoiceId: $invoiceId) {
    _id
    patientType
    inpatientDetails {
      ward
      inpatientNumber
      admission
      discharge
    }
  }
}
    `;

/**
 * __useInvoicePatientDetailsQuery__
 *
 * To run a query within a React component, call `useInvoicePatientDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicePatientDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicePatientDetailsQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useInvoicePatientDetailsQuery(baseOptions: Apollo.QueryHookOptions<InvoicePatientDetailsQuery, InvoicePatientDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoicePatientDetailsQuery, InvoicePatientDetailsQueryVariables>(InvoicePatientDetailsDocument, options);
      }
export function useInvoicePatientDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoicePatientDetailsQuery, InvoicePatientDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoicePatientDetailsQuery, InvoicePatientDetailsQueryVariables>(InvoicePatientDetailsDocument, options);
        }
export type InvoicePatientDetailsQueryHookResult = ReturnType<typeof useInvoicePatientDetailsQuery>;
export type InvoicePatientDetailsLazyQueryHookResult = ReturnType<typeof useInvoicePatientDetailsLazyQuery>;
export type InvoicePatientDetailsQueryResult = Apollo.QueryResult<InvoicePatientDetailsQuery, InvoicePatientDetailsQueryVariables>;